import { render, staticRenderFns } from "./welcomeintend.vue?vue&type=template&id=0957b6a9&scoped=true"
import script from "./welcomeintend.vue?vue&type=script&lang=js"
export * from "./welcomeintend.vue?vue&type=script&lang=js"
import style0 from "./welcomeintend.vue?vue&type=style&index=0&id=0957b6a9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0957b6a9",
  null
  
)

export default component.exports